import { lazy } from 'react'

const ArqueoCajaGestionApp = lazy(() => import('./view/ArqueoCajaGestion'))
const ArqueoCajaConsultarApp = lazy(() => import('./view/ArqueoCajaConsultar'))
export const arqueosCajaRoutesMap = {
  gestion: {
    path: '/arqueo/gestion',
    name: 'Gestión de Arqueos',
  },
  consultar: {
    path: '/arqueo/consultar/:id',
    name: 'Consultar Arqueo',
  },
}

const arqueosCajaRoutes = [
  {
    path: arqueosCajaRoutesMap.gestion.path,
    name: arqueosCajaRoutesMap.gestion.name,
    element: <ArqueoCajaGestionApp />,
  },
  {
    path: arqueosCajaRoutesMap.consultar.path,
    name: arqueosCajaRoutesMap.consultar.name,
    element: <ArqueoCajaConsultarApp />,
  },
]
export default arqueosCajaRoutes
